$(() => {
  if ($('#first-time-modal')) {
    $('#first-time-modal').modal('show');
  }
});
